import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ModalComponent } from '@components/modals/modal-template/modal.component';

@NgModule({
  imports: [CommonModule],
  exports: [ModalComponent],
  declarations: [ModalComponent],
})
export class ModalTemplateModule {}
